import Icon from "core/icon/Icon";
import "./Modal.scss";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import Button from "core/buttons/button/Button";
import {
  LANG,
  STATUS_MISSION,
  MISSION_IN_PROGRESS_LABEL,
} from "constants/constants";

function MissionsToolsModal({ missionData, userScope, closeModal, lang }) {
  const {
    slug: mission_slug,
    client,
    consultant,
    manager,
    job,
    status,
    mission_start_date,
    duration,
    TJ,
    mission_title,
    desc,
  } = missionData;

  const isInProgressMission = [STATUS_MISSION.ONE, STATUS_MISSION.FDM].includes(
    status?.props?.id
  );

  const inProgress =
    lang === LANG.FR ? MISSION_IN_PROGRESS_LABEL.FR : MISSION_IN_PROGRESS_LABEL.EN;

  const leftData = [
    {
      id: "client_name",
      defaultMessage: "Client :",
      value: client,
    },
    {
      id: "cslt_tools",
      defaultMessage: "Consultant / Sous-Traitant :",
      value: consultant,
    },
    {
      id: "manager_tools",
      defaultMessage: "Manager :",
      value: manager,
    },
    {
      id: "job_tools",
      defaultMessage: "Métier :",
      value: job,
    },
  ];

  const rightData = [
    {
      id: "mission_start_date",
      defaultMessage: "Date de début :",
      value: mission_start_date,
    },
    {
      id: "duration",
      defaultMessage: "durée :",
      value: `${duration} ${isInProgressMission ? inProgress : ""}`,
    },
    {
      id: "TJ_tools",
      defaultMessage: "TJ :",
      value: TJ,
    },
    {
      id: "status_tools",
      defaultMessage: "Statut :",
      value: status,
    },
  ];

  const builLeftData = (titlesData) => {
    return titlesData?.map((item, index) => (
      <div className="data-wrapper" key={index}>
        <strong>
          <FormattedMessage id={item.id} defaultMessage={item.defaultMessage} />
        </strong>
        <span className="data-content">{item.value}</span>
      </div>
    ));
  };

  return (
    <>
      <div className="overlay-style" />
      <div className="tool-modal-style missions-tools-modal">
        <div className="header">
          <div className="title">
            <Icon color="deep-purple" icon="folder" marginRight={8} />
            <Typography
              className="title-3 violet text-uppercase"
              type="h2"
              label={
                <FormattedMessage
                  id="desc_mission"
                  defaultMessage="Descriptif mission"
                />
              }
            />
          </div>
          <Icon color="gray-200" icon="close" onClick={closeModal} />
        </div>
        <div className="body">
          <div className="job-title">
            <a
              href={`/${userScope}/missions/${mission_slug}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {mission_title}
            </a>
          </div>
          <div className="mission-top-content">
            <div className="left-part">{builLeftData(leftData)}</div>
            <div className="right-part">{builLeftData(rightData)}</div>
          </div>
          <div className="desc-mission">
            <strong>
              <FormattedMessage
                id="desc_mission"
                defaultMessage="Descriptif de la mission :"
              />
            </strong>
            <span className="data-content">{desc}</span>
          </div>
        </div>
        <div className="footer">
          <Button
            className="btn-hover-color"
            size="small"
            color="blue"
            onClick={closeModal}
          >
            <FormattedMessage id={"close"} defaultMessage={"Fermer"} />
          </Button>
        </div>
      </div>
    </>
  );
}

export default MissionsToolsModal;
